import { get } from 'lodash'
import { useRef } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { List } from 'semantic-ui-react'

import Button from '@/components/Button'
import { Text } from '@/components/Form'
import defaultProps from '@/components/Form/defaultProps'
import Field from '@/components/Form/Field'
import propTypes from '@/components/Form/propTypes'
import cn from '@/utilities/cn'

import DomainName from './DomainName'
import messages from './messages'

import './index.scss'

function DomainWhitelistField(props: any) {
  const intl = useIntl()

  const formikRef = useRef<any>()

  // @ts-expect-error
  const addAddress = ([name]) => {
    const newDomainAddress = get(formikRef.current.values.currentMicroapp.configuration, 'newDomainAddress', '')
    const addresses = [...get(formikRef.current.values, name, [])]

    if (
      newDomainAddress.length > 0 &&
      !addresses.includes(newDomainAddress) &&
      !Object.hasOwn(formikRef.current.errors, 'currentMicroapp.configuration.newDomainAddress')
    ) {
      formikRef.current.setFieldValue(name, [...addresses, newDomainAddress], false)
      formikRef.current.setFieldValue('currentMicroapp.configuration.newDomainAddress', '')
    } else if (addresses.includes(newDomainAddress)) {
      formikRef.current.setFieldValue('currentMicroapp.configuration.newDomainAddress', '')
    }
  }

  const setEditableAddress = (name: any, index: any) => {
    const addresses = [...get(formikRef.current.values, name, [])]
    const address = addresses[index]
    formikRef.current.setFieldValue('currentMicroapp.configuration.editableAddress', { index: index, address: address })
  }

  const editAddress = (name: any, index: any, address: any) => {
    const addresses = [...get(formikRef.current.values, name, [])]

    if (
      address &&
      address.length > 0 &&
      !addresses.includes(address) &&
      !Object.hasOwn(formikRef.current.errors, 'currentMicroapp.configuration.editableAddress.address')
    ) {
      addresses[index] = address
      formikRef.current.setFieldValue(name, [...addresses], false)
    }

    formikRef.current.setFieldValue('currentMicroapp.configuration.editableAddress', { index: -1, address: '' })
  }

  const removeAddress = (name: any, index: any) => {
    const addresses = [...get(formikRef.current.values, name, [])]
    addresses.splice(index, 1)
    formikRef.current.setFieldValue(name, [...addresses], false)
  }

  return (
    <Field
      {...props}
      className={cn('form__address', props.className)}
      render={({ formik, ...field }: any) => {
        const addresses = get(formik.values, field.name, [])
        const editableAddress = get(formik.values, 'currentMicroapp.configuration.editableAddress', {})
        formikRef.current = formik
        return (
          <>
            <div className="domain-input-group">
              <Text
                name="currentMicroapp.configuration.newDomainAddress"
                placeholder={intl.formatMessage(messages.urlPlaceholder)}
                type="url"
              />
              <Button color="secondary" onClick={addAddress.bind(null, [field.name])}>
                {intl.formatMessage(messages.addDomain)}
              </Button>
            </div>

            {addresses.length > 0 && [
              <label className="field__label" key="added-urls">
                {<FormattedMessage {...messages.addedURLs} />}
              </label>,
              <div className="field__set domain-addresses" key="domain-addresses">
                <List>
                  {addresses.map((address: any, index: any) => {
                    return (
                      <List.Item key={`${field.name}.${index}`}>
                        <DomainName
                          key={`${field.name}.${index}`}
                          name={address}
                          fieldName={field.name}
                          index={index}
                          removeAddress={removeAddress}
                          editableAddress={editableAddress}
                          setEditableAddress={setEditableAddress}
                          editAddress={editAddress}
                        />
                        {index !== addresses.length - 1 && <hr className="additional-fields__divider" />}
                      </List.Item>
                    )
                  })}
                </List>
              </div>
            ]}
          </>
        )
      }}
    />
  )
}

DomainWhitelistField.displayName = 'DomainWhitelistField'
DomainWhitelistField.propTypes = { ...propTypes }
DomainWhitelistField.defaultProps = { ...defaultProps }

export default DomainWhitelistField
